import { debouncedFunderSearchByParams } from './search'

export const RESET_FILTERS = 'RESET_FILTERS'
export const SET_FILTER_BY_KEY = 'SET_FILTER_BY_KEY'

export const resetFilters = () => dispatch => {
  dispatch({ type: RESET_FILTERS })
}

export const setFilterByKey =
  (filter, { triggerSearch = true } = {}) =>
  dispatch => {
    dispatch({ type: SET_FILTER_BY_KEY, payload: { filter } })
    if (triggerSearch) {
      debouncedFunderSearchByParams(dispatch)
    }
  }
